import React from 'react'

import { Typo } from 'components/_old/Typo'

import { Card } from 'components/atoms/Card'
import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { getColor, formatValue } from '../model'

type PastPerformanceCardProps = {
  title: string
  value?: string | number
}

function PastPerformanceCard({ title, value }: PastPerformanceCardProps): JSX.Element | null {
  if (!value) {
    return null
  }

  return (
    <Card level={0}>
      <Paper top={16} right={16} bottom={16} left={16}>
        <Typography size={14} lineHeight="small" color="additional">
          <Typo>{title}</Typo>
        </Typography>
        <Paper top={8}>
          <Typography size={16} lineHeight="small" color={getColor(value)}>
            <Typo>{formatValue(value)}</Typo>
          </Typography>
        </Paper>
      </Paper>
    </Card>
  )
}

export { type PastPerformanceCardProps, PastPerformanceCard }
